const ThemeAgent = {
  // Static method to immediately apply theme from localStorage
  immediateInit() {
    const savedTheme = localStorage.getItem('theme') || 'light';
    // Add theme as a data attribute on html/body to avoid FOUC
    document.documentElement.setAttribute('data-theme', savedTheme);
    // Return the theme for potential use
    return savedTheme;
  },

  init(element) {
    // Apply saved theme
    const savedTheme = localStorage.getItem('theme') || 'light';
    this.applyTheme(savedTheme);
    
    // Listen for theme change requests
    window.addEventListener('theme-change-request', e => {
      this.applyTheme(e.detail.theme);
    });
  },
  
  applyTheme(theme) {
    // Set the theme attribute on root element for instant CSS effect
    document.documentElement.setAttribute('data-theme', theme);
    
    // Find all theme contexts using bracket notation
    const contexts = document.querySelectorAll('[class*="context[theme_"]');
    
    // Update each context
    contexts.forEach(context => {
      // Remove all theme classes with bracket notation
      context.className = context.className.replace(/context\[theme_\w+\]/g, '').trim();
      
      // Add new theme class with bracket notation
      context.classList.add(`context[theme_${theme}]`);
    });
    
    // Save preference
    localStorage.setItem('theme', theme);
    
    // Notify theme changed
    window.dispatchEvent(new CustomEvent('theme-changed', {
      detail: { theme }
    }));
  },
  
  destroy() {
    window.removeEventListener('theme-change-request', this.applyTheme);
  }
};

export default ThemeAgent;